module.exports = __webpack_public_path__ + "static/media/sweat.76615da1.png";